// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emailSignature[data-v-01359762] {\n  min-height: 90px;\n  min-width: 600px;\n  max-height: 150px;\n  max-width: 650px;\n}\n#emailSignatureDropzone[data-v-01359762] {\n  border: 2px dashed #3291ef;\n}", ""]);
// Exports
module.exports = exports;
